import { DEVICES_PAGE_TAB } from 'common/utils/constants';

export function selectUserPreferences(state) {
  return state.data.userPreferences;
}

export function createDeviceSetsSelector(activeTab) {
  switch (activeTab) {
    case DEVICES_PAGE_TAB.pivot:
      return (state) => state.data.pivotDeviceSets;
    case DEVICES_PAGE_TAB.echo:
      return (state) => state.data.echoDeviceSets;
    case DEVICES_PAGE_TAB.all:
    default:
      return (state) => state.data.allDeviceSets;
  }
}

export function createActiveFiltersSelector(activeTab) {
  switch (activeTab) {
    case DEVICES_PAGE_TAB.pivot:
      return (state) => state.data.pivotFilterDictionary;
    case DEVICES_PAGE_TAB.echo:
      return (state) => state.data.echoFilterDictionary;
    case DEVICES_PAGE_TAB.all:
    default:
      return (state) => state.data.allDevicesFilterDictionary;
  }
}

export function selectActiveSelectedDeviceDictionary(state) {
  switch (state.ui.devicesPage.activeTab) {
    case DEVICES_PAGE_TAB.pivot:
      return state.data.selectedDevicesDataPivotTab;
    case DEVICES_PAGE_TAB.echo:
      return state.data.selectedDevicesDataEchoTab;
    case DEVICES_PAGE_TAB.all:
    default:
      return state.data.selectedDevicesDataAllDevicesTab;
  }
}

export function selectStoredBundleDictionary(state) {
  return state.data.bundlesStorage.storedBundlesDictionary;
}

export function createStatusSelector(statusName) {
  return (state) => state.statuses[statusName];
}

export function selectDeviceGroups(state) {
  return state.ui.devicesPage.deviceGroups;
}

export function selectSelectedDeviceGroupName(state) {
  return state.ui.devicesPage.selectedDeviceGroupName;
}

export function selectToastNotifications(state) {
  return state.ui.sharedPages.toastNotifications;
}

export function selectActiveTabName(state) {
  return state.ui.devicesPage.activeTab;
}

export function selectActiveTab(state) {
  switch (selectActiveTabName(state)) {
    case DEVICES_PAGE_TAB.pivot:
      return state.ui.devicesPage.pivotTab;
    case DEVICES_PAGE_TAB.echo:
      return state.ui.devicesPage.echoTab;
    case DEVICES_PAGE_TAB.all:
    default:
      return state.ui.devicesPage.allDevicesTab;
  }
}

export function selectActiveDeviceDisplayMode(state) {
  const { deviceDisplayMode } = selectActiveTab(state);

  return deviceDisplayMode;
}

export function selectChartConsole(state) {
  return state.data.chartConsole;
}

export function selectChartSet(state) {
  return state.ui.chartExplorerPage;
}
